import { mc } from './constants.ts'

type VersionKey = 'v2' | 'v3' | 'v4' | 'v1'

type TargetMap = Record<number, number>

const VERSION_TARGETS: Record<VersionKey, TargetMap> = {
  v2: {
    964: 70
  },
  v3: {},
  v4: {
    1: 11.5,
    56: 51.9,
    8453: 11.5,
    42161: 11.5,
    137: 12558,
    11155111: 0.5
  },
  v1: {}
}

const FALLBACK_TARGETS: TargetMap = { ...mc }

const clampPercent = (value: number) => {
  if (!Number.isFinite(value)) return 0
  if (value < 0) return 0
  if (value > 100) return 100
  return value
}

export const getTargetMarketCapNative = (
  chainId: number,
  versionType?: string
): number | undefined => {
  const version = String(versionType || '')
    .toLowerCase()
    .trim() as VersionKey
  if (version && VERSION_TARGETS[version]?.[chainId] != null) {
    return VERSION_TARGETS[version][chainId]
  }
  if (FALLBACK_TARGETS[chainId] != null) {
    return FALLBACK_TARGETS[chainId]
  }
  return undefined
}

type ProgressArgs = {
  chainId: number
  versionType?: string
  tokenPriceRaw?: number | string | bigint | null
  lpCreated?: boolean
}

export const calculateBondingProgress = ({
  chainId,
  versionType,
  tokenPriceRaw,
  lpCreated
}: ProgressArgs): number => {
  if (lpCreated) return 100
  const target = getTargetMarketCapNative(chainId, versionType)
  if (!target || target <= 0) return 0
  if (tokenPriceRaw == null) return 0
  const priceNumeric = Number(tokenPriceRaw)
  if (!Number.isFinite(priceNumeric) || priceNumeric <= 0) return 0
  const tokenPriceNative = priceNumeric / 1e12
  const marketCapNative = tokenPriceNative * 1e9
  const percent = (marketCapNative * 100) / target
  return clampPercent(percent)
}

export const calculateMarketCapNative = (
  tokenPriceRaw?: number | string | bigint | null
) => {
  if (tokenPriceRaw == null) return 0
  const priceNumeric = Number(tokenPriceRaw)
  if (!Number.isFinite(priceNumeric) || priceNumeric <= 0) return 0
  const tokenPriceNative = priceNumeric / 1e12
  return tokenPriceNative * 1e9
}
